import { render, staticRenderFns } from "./ResourceListItemSideBar.vue?vue&type=template&id=5484a675&"
import script from "./ResourceListItemSideBar.vue?vue&type=script&lang=js&"
export * from "./ResourceListItemSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports